import { Box, Button } from '@mui/material';

import DebugFlowSelector from './DebugFlowSelector';
import { useStyles } from './styles';

interface IDebugOverlayProps {
  startFlow: (flowId: string) => void;
  stopPlayer: () => void;
  generateGreetingsAudio: () => void;
  fetchScripts: () => void;
  fetchParticipantProgress: () => void;
  resetProgress: () => void;
}

const DebugOverlay = ({
  startFlow,
  stopPlayer,
  generateGreetingsAudio,
  fetchScripts,
  fetchParticipantProgress,
  resetProgress,
}: IDebugOverlayProps) => {
  const classes = useStyles();

  return (
    <Box sx={classes.debugOverlay}>
      <DebugFlowSelector
        onStartFlow={(flowId) => {
          stopPlayer();
          resetProgress();
          startFlow(flowId);
        }}
      />
      <Box sx={{ mt: 3 }}>
        <Button
          sx={classes.debugButton}
          onClick={() => generateGreetingsAudio()}
        >
          Greetings test
        </Button>
        <Button sx={classes.debugButton} onClick={() => fetchScripts()}>
          Fetch scripts data
        </Button>
        <Button
          sx={classes.debugButton}
          onClick={() => fetchParticipantProgress()}
        >
          Fetch progress data
        </Button>
        <Button sx={classes.debugButton} onClick={() => resetProgress()}>
          Reset progress data
        </Button>
      </Box>
    </Box>
  );
};

export default DebugOverlay;
